$(document).ready(function ()
{

	$('.event-by-timings .timing-toggle').click(function(e)
	{
		e.preventDefault();
		var the_num = $(this).data('timing-toggle');
		var the_pair = '#contentToggle-' + the_num;
		if($(this).hasClass('content-open'))
		{
			$(this).removeClass('content-open');
			$(this).addClass('content-concealed');
			$(the_pair).removeClass('open');
			$(the_pair).addClass('concealed');
		}
		else
		{
			$(this).addClass('content-open');
			$(this).removeClass('content-concealed');
			$(the_pair).addClass('open');
			$(the_pair).removeClass('concealed');

		}
	});

});